import { MockAdapter } from "./MockAdapter";
import { DataverseAdapter } from "./DataverseAdapter";
import { PowerSdkAdapter } from "./PowerSdkAdapter";
import { HttpWhmcsAdapter, MockWhmcsAdapter, } from "./WhmcsAdapter";
let cached = null;
let cachedWhmcs = null;
let tokenProvider = null;
/**
 * AuthProvider calls this once authentication completes (Dataverse mode).
 * Resets the cached adapter so the next getDataAdapter() picks up the token.
 */
export function setTokenProvider(p) {
    tokenProvider = p;
    cached = null;
}
/**
 * Returns the configured data adapter. Picks the implementation from
 * VITE_BACKEND at boot — no other code branches on host.
 *
 * In Dataverse mode the adapter uses a deferred token lookup: the
 * underlying network call resolves the token at request time via the
 * provider registered by AuthProvider, so pages can construct the
 * adapter before sign-in completes without throwing.
 */
export function getDataAdapter() {
    if (cached)
        return cached;
    const mode = (import.meta.env.VITE_BACKEND ?? "mock");
    switch (mode) {
        case "dataverse":
            cached = new DataverseAdapter({
                baseUrl: import.meta.env.VITE_DATAVERSE_URL,
                getToken: async () => {
                    if (!tokenProvider) {
                        throw new Error("Not signed in: token provider unavailable.");
                    }
                    return tokenProvider();
                },
            });
            return cached;
        case "powersdk":
            cached = new PowerSdkAdapter();
            return cached;
        case "mock":
        default:
            cached = new MockAdapter();
            return cached;
    }
}
/**
 * Returns the WHMCS posting adapter. In `mock` mode the post is synthetic
 * (no network). In `dataverse` and `powersdk` modes the post hits the SWA
 * managed function /api/whmcs-billable — same-origin, no client-side secrets.
 * The function forwards to the wrapper at
 * whmcs-api-wrapper-app.azurewebsites.net with the X-API-Key header.
 */
export function getWhmcsAdapter() {
    if (cachedWhmcs)
        return cachedWhmcs;
    const mode = (import.meta.env.VITE_BACKEND ?? "mock");
    cachedWhmcs = mode === "mock" ? new MockWhmcsAdapter() : new HttpWhmcsAdapter();
    return cachedWhmcs;
}
/** Test helper — resets the cached singleton (used by storybook/dev only). */
export function __resetAdapter() {
    cached = null;
    cachedWhmcs = null;
}
